import { AgmCoreModule } from '@agm/core';
import { PlatformModule } from '@angular/cdk/platform';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ActivatedRouteSnapshot, RouterModule, RouterStateSnapshot } from '@angular/router';
import { NgbCarouselModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { DataTablesModule } from 'angular-datatables';
import { GtagModule } from 'angular-gtag';
import { IvyCarouselModule } from 'angular-responsive-carousel';
import { HotkeyModule } from 'angular2-hotkeys';
import { MatCarouselModule } from 'ng-mat-carousel';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { Ng2SearchPipeModule } from 'ng2-search-filter';
import { AutosizeModule } from 'ngx-autosize';
import { NgxGoogleAnalyticsModule } from 'ngx-google-analytics';
import { LottieModule } from 'ngx-lottie';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { PERFECT_SCROLLBAR_CONFIG, PerfectScrollbarConfigInterface, PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { ToastrModule } from 'ngx-toastr';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { MultiTranslateHttpLoader } from 'ngx-translate-multi-http-loader';
import { environment } from '../environments/environment';
import { AppRoutes } from './app-routing.module';
import { AppComponent } from './app.component';
import { LangTranslateModule } from './lang-translate/lang-translate.module';
import { BlankComponent } from './layouts/blank/blank.component';
import { FullComponent } from './layouts/full/full.component';
import { MaterialModule } from './material/material.module';
import { BreadcrumbComponent } from './shared/breadcrumb/breadcrumb.component';
import { NavigationComponent } from './shared/components/header-navigation/navigation.component';
import { GoogleAnalyticsService } from './shared/services/google-analytics-events.service';
import { SidebarComponent } from './shared/components/sidebar/sidebar.component';
import { SpinnerComponent } from './shared/spinner.component';
import { NgCircleProgressModule } from 'ng-circle-progress';
import { NgxNumToWordsModule } from 'ngx-num-to-words';
import { QuillModule } from 'ngx-quill';
import { MatChipsModule } from '@angular/material/chips';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatButtonModule } from '@angular/material/button';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { ChatBotService } from './shared/services/ai-agent/chatbot.service';
import {NgxImageCompressService} from 'ngx-image-compress';

export function playerFactory() {
  return import('lottie-web');
}

export function HttpLoaderFactory(http: HttpClient): MultiTranslateHttpLoader {
  return new MultiTranslateHttpLoader(http, [
    {prefix: '../assets/translate/authentication/', suffix: '.json'},
    {prefix: '../assets/translate/etudes/', suffix: '.json'},
    {prefix: '../assets/translate/global/', suffix: '.json'},
    {prefix: '../assets/translate/datahub/', suffix: '.json'},
    {prefix: '../assets/translate/looka/', suffix: '.json'},
  ]);
}

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true,
  wheelSpeed: 1,
  wheelPropagation: true,
  minScrollbarLength: 20
};
@NgModule({
  declarations: [
    AppComponent,
    SpinnerComponent,
    FullComponent,
    BlankComponent,
    NavigationComponent,
    BreadcrumbComponent,
    SidebarComponent,
  ],
    imports: [
        BrowserModule,
        PlatformModule,
        BrowserAnimationsModule,
        FormsModule,
        MatChipsModule,
        IvyCarouselModule,
        MatCarouselModule.forRoot(),
        NgbCarouselModule,
        ToastrModule.forRoot(),
        ReactiveFormsModule,
        DataTablesModule,
        PdfViewerModule,
        HttpClientModule,
        NgbModule,
        Ng2SearchPipeModule,
        RouterModule.forRoot(AppRoutes, {scrollPositionRestoration: 'enabled'}),
        PerfectScrollbarModule,
        NgMultiSelectDropDownModule.forRoot(),
        AgmCoreModule.forRoot({apiKey: 'AIzaSyDoliAneRffQDyA7Ul9cDk3tLe7vaU4yP8'}),
        MatProgressBarModule,
        MaterialModule,
        MatAutocompleteModule,
        BrowserModule,
        BrowserAnimationsModule,
        HttpClientModule,
        TranslateModule.forRoot({
          loader: {
            provide: TranslateLoader,
            useFactory: HttpLoaderFactory,
            deps: [HttpClient]
          }
        }),
        LangTranslateModule,
        NgxMatSelectSearchModule,
        NgxGoogleAnalyticsModule.forRoot('traking-code'),
        GtagModule.forRoot(environment.gaConfig),
        LottieModule.forRoot({player: playerFactory}),
        HotkeyModule.forRoot(),
        NgCircleProgressModule.forRoot({
            radius: 100,
            outerStrokeWidth: 16,
            innerStrokeWidth: 8,
            outerStrokeColor: '#F7BC31',
            innerStrokeColor: '#ffffff',
            animationDuration: 300
        }),
        NgxNumToWordsModule,
        AutosizeModule,
        QuillModule.forRoot(),
        MatChipsModule,
        AngularEditorModule,
        DragDropModule,
        MatButtonModule,
    ],
  exports: [RouterModule],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ],
  providers: [
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
    },
    GoogleAnalyticsService,
    {
      provide: 'AuthorisationGuard',
      useValue: (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => true
    },
    ChatBotService,
    NgxImageCompressService
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
